<template>
	<thead>
		<tr>
			<th>{{ $t('inventory_modal.th_rule_type') }}</th>

			<th v-for="field in fieldsList" :key="field.key">
				<th-ordering-button
					:name="field.key"
					:descending="descending"
					:order-by="orderBy"
					:disabled="disabled"
					@ordering="handleButtonClick"
				>{{ field.caption }}</th-ordering-button>
			</th>

			<th>{{ $t('campaign.widget_ad_plays_title') }}</th>
			<th>{{ $t('campaign.widget_impressions_title') }}</th>
			<th>{{ $t(`inventory_modal.th_${costField}`, { currency }) }}</th>
		</tr>
	</thead>
</template>


<script>
import OriginalHeaderRow from '@/ui-overrides/default/pages/request/create/inventory-details-modal/inventory-table-header-row.vue';
import ThOrderingButton from './th-ordering-button.vue';

export default {
	name: 'V2InventoryTableHeaderRow',

	extends: OriginalHeaderRow,

	components: {
		ThOrderingButton,
	},
};
</script>
